<template>
    <div>
        <div class="d-flex">
            <div
                v-for="(item,i) in items"
                v-show="!item.hidden"
                :class="{active: local && local.id==item.id, 'next-active': checkNextActive(item), last: i===items.length-1, 'edited': item.index < local.index}"
                class="flex-grow-1 filter-segment"
                @click="onClick(item)"
                :data-test="`create-intervention-stepper-${item.id}`"
                :key="`stepper-navigation-`+i"
            >
                <div style="margin-left: -40px;">
                    <v-icon v-if="item.index < local.index" class="mr-2" color="#050F2D">fal fa-check</v-icon>{{item.name}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StepperNavigation',
        props: {
            value: {},
            disabled: {
                type: Boolean,
                default: false
            },
            nextDisabled: {
                type: Boolean,
                default: false
            },
            items: {
                default: () => []
            },
        },
        watch: {
            value: {
                handler(v) {
                    this.local = v
                },
                immediate: true
            },
            local(v) {
                this.$emit('input', v)
            }
        },
        data() {
            return {
                local: null
            }
        },
        mounted() {
            if (!this.value && this.items.length>0) this.local = this.items[0] 
        },
        methods: {
            onClick(item) {
                if (this.disabled) {
                    // All movement must be disabled in this scenario, even previously completed steps
                    return
                }

                if (this.nextDisabled) {
                    let currentIndex = this.items.findIndex(itm => itm === this.local)
                    let clickedIndex = this.items.findIndex(itm => itm === item)

                    // User cannot proceed further into the stepper until the current
                    // page is completed.  Backwards movement should be allowed.
                    if (clickedIndex > currentIndex) {
                        return
                    }
                }

                this.local = item
            },
            checkNextActive(item) {
                // if attendance (monitor is hidden), we want to skip the progress monitor header
                let isAttendance = this.items.find(x => x.id === 'monitor').hidden
                let idx = (isAttendance && item.id !== 'review') || !isAttendance ? 1 : 0
                // if attendance, want to make sure to apply 'next-active' class to schedule header when on review
                if (isAttendance && item.id === 'schedule' && this.local.id === 'review') return true
                return this.local && item.index < this.items.length-idx && this.items[item.index+idx].id === this.local.id
            }
        },
    }
</script>

<style lang="scss" scoped>
.filter-segment {
    cursor: pointer;
    line-height: 36px;
    padding: 8px 16px 8px 16px;
    background: #ECEDF1;
    color: #050F2D;
    font-size: 14px;
    flex-basis: 0;
    display: flex;
    justify-content: center;

    background-image:
        linear-gradient( -60deg, #ECEDF1 25px, transparent 25px),
        linear-gradient(-125deg, #ECEDF1 25px, transparent 25px),
        linear-gradient( -60deg, white 32px, transparent 32px),
        linear-gradient(-125deg, white 32px, transparent 32px),
        linear-gradient( -60deg, #ECEDF1 40px, transparent 40px),
        linear-gradient(-125deg, #ECEDF1 40px, transparent 40px);

    &.next-active:not(.last) {
        background-image:
            linear-gradient( -60deg, #80B6C7 25px, transparent 25px),
            linear-gradient(-125deg, #80B6C7 25px, transparent 25px),
            linear-gradient( -60deg, white 32px, transparent 32px),
            linear-gradient(-125deg, white 32px, transparent 32px),
            linear-gradient( -60deg, #E5F0F4 40px, transparent 40px),
            linear-gradient(-125deg, #E5F0F4 40px, transparent 40px);
        color: #050F2D;
    }

    &.active {
        background: #80B6C7;
        background-image:
            linear-gradient( -60deg, #ECEDF1 25px, transparent 25px),
            linear-gradient(-125deg, #ECEDF1 25px, transparent 25px),
            linear-gradient( -60deg, white 32px, transparent 32px),
            linear-gradient(-125deg, white 32px, transparent 32px),
            linear-gradient( -60deg, #80B6C7 40px, transparent 40px),
            linear-gradient(-125deg, #80B6C7 40px, transparent 40px);
        color: #050F2D;
    }

    &.last {
        background-image: none;
    }

    &.edited {
        background: #E5F0F4;
        background-image:
            linear-gradient( -60deg, #E5F0F4 25px, transparent 25px),
            linear-gradient(-125deg, #E5F0F4 25px, transparent 25px),
            linear-gradient( -60deg, white 32px, transparent 32px),
            linear-gradient(-125deg, white 32px, transparent 32px),
            linear-gradient( -60deg, #E5F0F4 40px, transparent 40px),
            linear-gradient(-125deg, #E5F0F4 40px, transparent 40px);
        color: #050F2D;
    }

}
</style>